import { captureException, setContext, withScope } from '@sentry/react';
import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';

const setBearer = (config: InternalAxiosRequestConfig) => {
  const accessToken = localStorage.getItem('@accessToken');
  if (accessToken) {
    const newConfig = config;
    newConfig.headers.Authorization = `Bearer ${accessToken}`;
    return newConfig;
  }

  return config;
};

export const customAxios = axios.create({
  baseURL: `${process.env.REACT_APP_SERVER_URL}/`,
  timeout: 1000 * 60,
  params: {},
});

customAxios.defaults.headers['Access-Control-Allow-Origin'] = '*';

customAxios.interceptors.request.use((config) => setBearer(config));
customAxios.interceptors.response.use(
  (res) => {
    return res.data;
  },
  async (error: AxiosError) => {
    const { response, config } = error;

    if (!response || !config || response.status === 401) {
      return Promise.reject(error);
    }

    const { method, url, params, data: reqData, headers } = config;
    const { status, data: resData } = response;

    setContext('API Request Detail', { method, url, params, reqData, headers });
    setContext('API Response Detail', { status, resData });

    withScope((scope) => {
      scope.setTag('type', 'api');
      scope.setTag('api-status', status ?? 'no-value');
      scope.setTag('api-data', resData ? JSON.stringify(resData) : 'no-value');

      scope.setFingerprint([method ?? 'unknown', url ?? 'unknown', String(status)]);

      captureException(error, {
        level: 'error',
        extra: {
          header: headers,
          response: resData,
          request: error.request,
          type: '네트워크 에러',
        },
      });
    });

    return Promise.reject(error);
  },
);
